export default {
  buttons: {
    send_code: 'Send Login Code',
  },
  placeholders: {
    mobile_number: 'Mobile Number',
  },
  feedback: {
    phone_number_required: 'Please enter your phone number',
  },
};
